<template>
  <div class="hero-section relative w-full min-h-[80vh] px-5 py-5">
    <HeroText />

    <!-- Desktop -->
    <!--    <div class="absolute inset-0 hidden md:flex justify-center items-center">-->
    <!--      <HeaderLogo />-->
    <!--    </div>-->

    <!-- Mobile -->
    <!--    <div class="flex justify-center items-center md:hidden my-4">-->
    <!--      <HeaderLogo />-->
    <!--    </div>-->

    <HeroAction />
  </div>
</template>

<script setup lang="ts">
import HeroText from './HeroText.vue'
import HeroAction from './HeroAction.vue'
import HeaderLogo from '@/components/header/HeaderLogo.vue'
</script>

<style scoped>
.hero-section {
  background:
    linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.8)),
    url('@/assets/images/set-whenever-bet/10-resized.jpeg');
  background-size: cover;
  background-position: center;
  color: #ffffff;
}
</style>
